var map = {
	"./osmTagToNameMapping-cs.template.ts": [
		25653,
		5653
	],
	"./osmTagToNameMapping-cs.ts": [
		46489,
		6489
	],
	"./osmTagToNameMapping-de.template.ts": [
		4918,
		4918
	],
	"./osmTagToNameMapping-de.ts": [
		25828,
		5828
	],
	"./osmTagToNameMapping-en.ts": [
		19200,
		9200
	],
	"./osmTagToNameMapping-hu.template.ts": [
		92002,
		2002
	],
	"./osmTagToNameMapping-hu.ts": [
		87072,
		7072
	],
	"./osmTagToNameMapping-it.template.ts": [
		55232,
		5232
	],
	"./osmTagToNameMapping-it.ts": [
		21422,
		1422
	],
	"./osmTagToNameMapping-pl.template.ts": [
		80971,
		971
	],
	"./osmTagToNameMapping-pl.ts": [
		34367,
		4367
	],
	"./osmTagToNameMapping-sk.template.ts": [
		17229,
		7229
	],
	"./osmTagToNameMapping-sk.ts": [
		53681,
		3681
	],
	"./osmTagToNameMapping-xx.template.ts": [
		87727,
		7727
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64712;
module.exports = webpackAsyncContext;